import {Interceptor} from '@jobseeker/common-core/lib/components/Inteceptor';
import {NavLayout, ResponsiveLayout, SeoLayout} from '@layouts';
import {getConfigByApp} from '@utils';
import {metaInfo} from '@configs';
import {HOME, FAQ} from '@constants';
import loadSEO from '@helpers/loadSEO';
import {wrapper} from '@jobseeker/common-core/lib/stores';
import {VersionVariants} from '@jobseeker/lotus/lib/enums/variants';
import FAQPage from '@components/Static/Faq';
import {useDispatch} from 'react-redux';
import useValidateAuth from '@jobseeker/common-core/lib/hooks/useValidateAuth';

type FaqProps = {
  seoConfig: object;
};

const Faq = ({seoConfig}: FaqProps) => {
  const metaData = getConfigByApp(metaInfo, HOME, true, FAQ);

  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();

  useValidateAuth(dispatch);

  const breadcrumbElements = [
    {
      name: 'Home',
      item: '/',
    },
    {
      name: 'Frequently Asked Questions',
      item: ``,
    },
  ];

  return (
    <Interceptor metaInfo={metaData}>
      <SeoLayout seoConfig={seoConfig} />
      <NavLayout>
        <ResponsiveLayout
          breadcrumbElements={breadcrumbElements}
          variant={VersionVariants.VERSION_TWO}
        >
          <FAQPage />
        </ResponsiveLayout>
      </NavLayout>
    </Interceptor>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  store => async () => {
    const seoConfig = await loadSEO(FAQ);

    store.dispatch({
      type: 'AppContext/set_current_page',
      payload: {page: FAQ},
    });

    return {
      props: {
        seoConfig,
      },
    };
  }
);

export default Faq;
